import { useMyMutation, MutationInfos, client } from '../helpers';
import { DeletePolicyInput, UpdatePolicyInput } from '../../apiTypes';
import { typePolicies } from './types';

function updatePolicies(variables: UpdatePolicyInput): MutationInfos {
    return {
        method: 'post',
        path: `/policies`,
        type: typePolicies.UPDATE_POLICIES,
        params: {
            ...variables,
        },
    };
}

function deletePolicies(variables: DeletePolicyInput): MutationInfos {
    return {
        method: 'delete',
        path: `/policies`,
        type: typePolicies.DELETE_POLICIES,
        params: {
            ...variables,
        },
    };
}

export function useUpdatePolicies(opts = {}) {
    return useMyMutation(updatePolicies, {
        ...opts,
        onSuccess: () => {
            client.invalidateQueries('policies');
            client.resetQueries('quotes');
        },
    });
}

export function useDeletePolicies() {
    return useMyMutation(deletePolicies, {
        onSuccess: () => {
            client.invalidateQueries('policies');
            client.resetQueries('quotes');
        },
    });
}
